import { render, staticRenderFns } from "./ProviderStreamsComparatorBar.vue?vue&type=template&id=575e7a5c&scoped=true"
import script from "./ProviderStreamsComparatorBar.vue?vue&type=script&lang=ts"
export * from "./ProviderStreamsComparatorBar.vue?vue&type=script&lang=ts"
import style0 from "./ProviderStreamsComparatorBar.vue?vue&type=style&index=0&id=575e7a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e7a5c",
  null
  
)

export default component.exports